import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { AbcDropDownBoxComponent } from 'libs/abc/ui-components/src/lib/core/src/abc-drop-down-box/abc-drop-down-box.component';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-resource-event-vehicle-downtime',
  templateUrl: './resource-event-vehicle-downtime.component.html',
  styleUrls: ['./resource-event-vehicle-downtime.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ResourceEventVehicleDowntimeComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  @ViewChild('dropDownDownReason', { static: true }) dropDownDownReason: AbcDropDownBoxComponent;

  constructor(
    resourceManagerService: ResourceManagerService,
    resourcesService: ResourcesService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }

  protected override onNavigationContextRefresh(): void {
    if (!this.dropDownDownReason.dataSource) {
      this.dropDownDownReason.setupForArrayData(
        this.resourcesNavigationContext.resourceEventGroup.resourceEventTypeGroup.resourceEventTypes,
        'id',
        'name'
      );
    }
  }

  async ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
